const { Component, RawHTML, useState, useEffect } = wp.element;

import Masonry from "masonry-layout";
import LoopItems from "./LoopItems";
import { dummyPosts } from "./dummy-posts";
import { dummyProducts } from "./dummy-products";

var myStore = wp.data.select("PPSFCStore");

function Html(props) {
	if (!props.warn) {
		return null;
	}

	var id = props.id;


	if (props.postData.post_content == null) {
		return null;
	}

	var [postData, setpostData] = useState(props.postData);
	var [PPSFCData, setPPSFCData] = useState(postData.post_content);

	var [globalOptions, setglobalOptions] = useState(PPSFCData.globalOptions);

	var [wrapper, setwrapper] = useState(PPSFCData.wrapper);
	var [itemsWrap, setitemsWrap] = useState(PPSFCData.itemsWrap);
	var [itemWrap, setitemWrap] = useState(PPSFCData.itemWrap);
	var [items, setitems] = useState(PPSFCData.items);
	var [loopLayout, setloopLayout] = useState(PPSFCData.loopLayout);
	var [masonryOptions, setmasonryOptions] = useState(
		PPSFCData.masonryOptions
	);
	var [pagination, setpagination] = useState(PPSFCData.pagination);

	const [loadingIconHtml, setloadingIconHtml] = useState("");
	const [loadMoreIconHtml, setloadMoreIconHtml] = useState("");
	const [previousIconHtml, setpreviousIconHtml] = useState("");
	const [nextIconHtml, setnextIconHtml] = useState("");

	useEffect(() => {
		var iconSrc = PPSFCData.pagination?.loadingIcon?.iconSrc;
		var loadingIconHtml = `<span class="${iconSrc}"></span>`;
		setloadingIconHtml(loadingIconHtml);

		var iconSrc = PPSFCData.pagination?.loadMoreIcon?.iconSrc;
		var loadMoreIconHtml = `<span class="${iconSrc}"></span>`;
		setloadMoreIconHtml(loadMoreIconHtml);

		var iconSrc = PPSFCData.pagination?.previousIcon?.iconSrc;

		console.log(iconSrc)
		var previousIconHtml = `<span class="${iconSrc}"></span>`;
		setpreviousIconHtml(previousIconHtml);

		var iconSrc = PPSFCData.pagination?.nextIcon?.iconSrc;
		var nextIconHtml = `<span class="${iconSrc}"></span>`;
		setnextIconHtml(nextIconHtml);




		setpagination(PPSFCData.globalOptions.pagination)

	}, [PPSFCData.globalOptions.pagination]);





	useEffect(() => {
		setpostData(props.postData);
	}, [props.postData]);

	useEffect(() => {
		setPPSFCData(postData.post_content);
		//setitems(postData.post_content.items);
	}, [postData]);

	useEffect(() => {
		setglobalOptions(PPSFCData.globalOptions);

		setwrapper(PPSFCData.wrapper);
		setitemsWrap(PPSFCData.itemsWrap);
		setitemWrap(PPSFCData.itemWrap);
		setitems(PPSFCData.items);
		setloopLayout(PPSFCData.loopLayout);
		setmasonryOptions(PPSFCData.masonryOptions);
		setTimeout(() => {
			loadMasonry();
		}, 2000);
	}, [PPSFCData]);






	function unescapeHTML(str) {
		const map = {
			"&amp;": "&",
			"&lt;": "<",
			"&gt;": ">",
			"&quot;": '"',
			"&#039;": "'",
		};
		return str.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g, function (match) {
			return map[match];
		});
	}



	var blockClass = "#ppsfc-" + postData.ID;

	function loadMasonry() {
		// var elemX = document.querySelectorAll("." + blockId);
		var elemX = document.querySelector(blockClass + " > .items");

		console.log(elemX);


		if (elemX != null) {
			// elemX.forEach((arg) => {
			// imagesLoaded(elemX, function () {
			var msnry = new Masonry(elemX, masonryOptions);
			// });
			// });
		}
	}
	useEffect(() => {


		setTimeout(() => {
			loadMasonry();
		}, 2000);
	}, [masonryOptions]);



	const Tree = ({ loopLayout, itemData }) => {
		return (
			<div>
				{loopLayout.map((node) => (
					<TreeNode key={node.id} node={node} itemData={itemData} />
				))}
			</div>
		);
	};







	const GenerateNodeHtml = ({ node, itemData }) => {
		var nodeType = node.type;
		var nodeId = node.id;

		var html = applyFilters("PPSFCElementHtml" + nodeType, '', itemData, node);

		return html;


	};

	const TreeNode = ({ node, itemData }) => {
		var nodeType = node.type;

		if (nodeType == "root" || nodeType == "container") {
			return (
				<div id={`element-${node.id}`} className={`${node.type}`}>
					{node.children && (
						<>
							{node.children.map((child) => (
								<TreeNode key={child?.id} node={child} itemData={itemData} />
							))}
						</>
					)}
				</div>
			);
		} else {
			return <GenerateNodeHtml node={node} itemData={itemData} />;
		}
	};









	return (
		<div className="px-10 py-10">
			<div id={`ppsfc-${id}`} className={`${wrapper?.options?.class} `}>
				<div className={`items ${itemsWrap?.options?.class} `}>
					{dummyProducts?.map((item, loopIndex) => {

						var children = PPSFCData.loopLayout[0]?.children ? PPSFCData.loopLayout[0]?.children : [];

						return (
							<div
								key={loopIndex}
								className={`${itemWrap?.options?.class} item`}>
								<LoopItems loopLayout={children} itemData={item} />
							</div>
						);
					})}
				</div>


				{PPSFCData.globalOptions.itemSource == "posts" && (
					<div class="pagination ">




						{PPSFCData.globalOptions?.pagination?.type == "next_previous" && (
							<>
								<span className="page-numbers prev">
									<span
										className=""
										dangerouslySetInnerHTML={{ __html: previousIconHtml }}
									/>
									{pagination?.previousText}

								</span>
								<span className="page-numbers next">

									{pagination?.nextText}
									<span
										className=""
										dangerouslySetInnerHTML={{ __html: nextIconHtml }}
									/>
								</span>
							</>
						)}
						{PPSFCData.globalOptions?.pagination?.type == "loadmore" && (
							<>
								<div className="page-numbers">

									<span
										dangerouslySetInnerHTML={{ __html: loadMoreIconHtml }}
									/>

									{pagination?.loadMoreText}

								</div>
							</>
						)}
						{PPSFCData.globalOptions?.pagination?.type == "infinite" && (
							<div className="page-numbers">

								{pagination.loadMoreText}
								<span
									dangerouslySetInnerHTML={{ __html: loadingIconHtml }}
								/>
							</div>
						)}


						{(PPSFCData.globalOptions?.pagination?.type == 'normal' || PPSFCData.globalOptions?.pagination?.type == 'ajax') && (
							<>

								<a class="prev page-numbers" href="#1" onClick={ev => {
									ev.preventDefault();
								}}>

									<span class="previous ">

										<span
											className=""
											dangerouslySetInnerHTML={{ __html: previousIconHtml }}
										/>
										{pagination?.previousText}</span>
								</a>
								<a class="page-numbers" href="#1" onClick={ev => {
									ev.preventDefault();
								}}>
									1
								</a>
								<span aria-current="page" class="page-numbers current">
									2
								</span>
								<a class="page-numbers" href="#3" onClick={ev => {
									ev.preventDefault();
								}}>
									3
								</a>
								<a class="page-numbers" href="#4" onClick={ev => {
									ev.preventDefault();
								}}>
									4
								</a>
								<span class="page-numbers dots">…</span>
								<a class="page-numbers" href="#6">
									6
								</a>
								<a class="next page-numbers" href="#3" onClick={ev => {
									ev.preventDefault();
								}}>
									<span class="next ">

										{pagination?.nextText}
										<span
											className=""
											dangerouslySetInnerHTML={{ __html: nextIconHtml }}
										/>
									</span>
								</a>

							</>
						)}


					</div>
				)}

			</div>
		</div>
	);
}

class PreviewMasonry extends Component {
	constructor(props) {
		super(props);
		this.state = { showWarning: true };
		this.handleToggleClick = this.handleToggleClick.bind(this);
	}

	handleToggleClick() {
		this.setState((state) => ({
			showWarning: !state.showWarning,
		}));
	}

	render() {
		var {
			postData,
			id,
		} = this.props;

		return (
			<Html
				postData={postData}
				id={id}
				warn={this.state.showWarning}
			/>
		);
	}
}

export default PreviewMasonry;
